// extracted by mini-css-extract-plugin
module.exports = {"clickable_label_fix":"beschikbare-software-koppelingen_clickable_label_fix__Oxg-1"};